module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedicationPage",
    attrs: {
      "id": "ded01"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }, [_c('p', {
    staticClass: "dedicationText"
  }, [_vm._v("I wrote parts of this book while staying at my in-laws house as my father-in-law fought his last few days against cancer. It was there, at his bedside, that I learned the true meaning of character, both from him and in watching the stream of caregivers who stood by his side.")]), _vm._v(" "), _c('p', {
    staticClass: "dedicationText"
  }, [_vm._v("To Hospice of St. Francis in Titusville, FL. Thank you for taking such beautiful, compassionate care of my incredible father-in-law who was able to die as he had lived—strong, proud, and loved.")])]), _c('p', {
    staticClass: "dedicationText"
  }, [_c('a', {
    attrs: {
      "id": "pagevii"
    }
  }, [_c('span', {
    staticClass: "xrefURL"
  })]), _c('a', {
    attrs: {
      "href": "http://www.hospiceofstfrancis.com",
      "target": "_blank"
    }
  }, [_vm._v("www.hospiceofstfrancis.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-032f3b07","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781439164341_ded01.vue
// module id = 72
// module chunks = 0